// extracted by mini-css-extract-plugin
export var infoItem = "_r6-2";
export var title = "_r6-0";
export var value = "_r6-1";